export default __webpack_public_path__ + "static/media/arrow-up.08248ba8.svg";